import gql from 'graphql-tag';

export default gql`
  fragment CommonObservations on Observations {
    temperature {
      value
      unit
      takenAt
    }
    bloodPressure {
      systolic
      diastolic
      takenAt
    }
    glucoseLevel {
      value
      unit
      takenAt
    }
    heartRate {
      value
      takenAt
    }
    o2SatLevel {
      value
      takenAt
    }
    ecgReport {
      ecgId
      url
      takenAt
    }
    spirometry {
      pef {
        value
        unit
      }
      fev1 {
        value
        unit
      }
      fvc {
        value
        unit
      }
      fev1OverFvc {
        value
        unit
      }
      fev6 {
        value
        unit
      }
      fef2575 {
        value
        unit
      }
      pefTime {
        value
        unit
      }
      eVol {
        value
        unit
      }
      takenAt
    }
  }
`;
